<template>
  <div class="view valet-overview" v-if="verified">
    <h6>{{ $t('registration.breadcrumb') }}</h6>
    <div>
      <router-link :to="`/${$i18n.locale}/valet/register`"><span class="link">{{ $t('valet.overview.newclientreg') }}</span></router-link>
    </div>
    <div class="search">
      <div class="search-input">
        <IconSearch />
        <Input type="text" :placeholder="$t('valet.overview.plate')" :value.sync="platesearch" uppercase no-outline no-tracking/>
      </div>
      <Button gray small :use-close="showCheckIns" @click="toggleCheckIns">{{ $t('valet.overview.checkins') }}</Button>
    </div>
    <Table :list="listData" :show-checkedins="showCheckIns" :plate-search="platesearch" />
  </div>
</template>

<script>
  import IconSearch from '@/assets/svg/icon-search.svg?inline';
  import Button from '@/components/ui/Button';
  import Table from '@/components/Table';
  import Input from '@/components/Input';

  export default {
    name: 'ValetOverview',
    components: {
      Input,
      Table,
      Button,
      IconSearch,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        platesearch: null,
        showCheckIns: false,
        verified: false,
        listData: [],
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    async created() {
      if (!this.$b.data.verified) {
        this.$router.push(`/${this.$i18n.locale}/valet/login`);
      }
      this.verified = this.$b.data.verified;

      const response = await this.$b.api.get('registrations/list');
      if (response.list) {
        this.listData = response.list;
      }
    },
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
      toggleCheckIns() {
        this.showCheckIns = !this.showCheckIns;
      },
    },
  };
</script>

<style lang="scss">
  @import '~scss/variables';
  @import '~scss/mixins';

  .view.valet-overview {
    padding: 25px 20px 0 20px;

    h1 {
      position: relative;
      @include font-daimler-cac();
      font-size: 3.4rem;
      margin: 0 0 55px;
      padding: 0;
    }
    h3 {
      @include font-daimler-cac();
      font-size: 2.8rem;
      margin: 45px 0 0 0;
      padding: 0;
    }
    h6 {
      position: relative;
      @include font-daimler-cs(400);
      font-size: 1.6rem;
      margin: 0;
      padding: 0;

      &:after {
        content: '';
        position: relative;
        display: block;
        height: 2px;
        width: 46px;
        background-color: $color-white;
        margin-top: 25px;
        margin-bottom: 30px;
      }
    }

    a {
      color: $color-gray;
      cursor: pointer;

      span.link {
        display: inline-block;
        &:before {
          display: inline-block;
          position: relative;
          content: '>';
          width: auto;
          height: inherit;
          margin-right: 8px;
          transform-origin: 50% 50%;
          transform: translate(0,1px) rotate(0) scale(1, 1.6);
        }
      }
    }

    .search {
      height: 52px;
      border-radius: 3px;
      margin: 38px 0 16px 0;
      padding: 0 16px 0 32px;
      background: $color-whisper;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .search-input {
        position: relative;
        width: 70%;
        display: flex;
        align-items: center;

        svg {
          display: inline-block;
          position: relative;
          top: -1px;
          width: 24px;
          height: 24px;
          pointer-events: none;
        }
        input {
          color: $color-black;
          &::placeholder {
            color: $color-gray;
          }
        }
      }
    }
  }
</style>
